export default function isFunction(value) {
    return !!(value && typeof value === 'function');
}
;
